export var CELL_STYLE;
(function (CELL_STYLE) {
    CELL_STYLE["TEXT"] = "t";
    CELL_STYLE["HEADER"] = "h";
    CELL_STYLE["SUBHEADER"] = "sh";
    CELL_STYLE["COEFFICIENT"] = "c";
    CELL_STYLE["COEFFICIENT_TEXT"] = "ct";
})(CELL_STYLE || (CELL_STYLE = {}));
export var CELL_ALIGN;
(function (CELL_ALIGN) {
    CELL_ALIGN["CENTER"] = "c";
    CELL_ALIGN["LEFT"] = "l";
    CELL_ALIGN["RIGHT"] = "r";
})(CELL_ALIGN || (CELL_ALIGN = {}));
export var COLUMN_WIDTH;
(function (COLUMN_WIDTH) {
    COLUMN_WIDTH["MEDIUM"] = "md";
    COLUMN_WIDTH["SMALL"] = "sm";
})(COLUMN_WIDTH || (COLUMN_WIDTH = {}));
export var SITE_TYPE;
(function (SITE_TYPE) {
    SITE_TYPE[SITE_TYPE["COM"] = 0] = "COM";
    SITE_TYPE[SITE_TYPE["CUPIS"] = 1] = "CUPIS";
})(SITE_TYPE || (SITE_TYPE = {}));
export var LOCK_STATE;
(function (LOCK_STATE) {
    LOCK_STATE[LOCK_STATE["UNBLOCKED"] = 0] = "UNBLOCKED";
    LOCK_STATE[LOCK_STATE["BLOCKED"] = 1] = "BLOCKED";
})(LOCK_STATE || (LOCK_STATE = {}));
export var STATE;
(function (STATE) {
    STATE[STATE["ENABLED"] = 1] = "ENABLED";
    STATE[STATE["DISABLED"] = 0] = "DISABLED";
})(STATE || (STATE = {}));
export var INFOGRAPHIC_INFO;
(function (INFOGRAPHIC_INFO) {
    INFOGRAPHIC_INFO[INFOGRAPHIC_INFO["AVAILABLE"] = 1] = "AVAILABLE";
    INFOGRAPHIC_INFO[INFOGRAPHIC_INFO["UNAVAILABLE"] = 0] = "UNAVAILABLE";
})(INFOGRAPHIC_INFO || (INFOGRAPHIC_INFO = {}));
export var CHANNEL_ACTION;
(function (CHANNEL_ACTION) {
    CHANNEL_ACTION[CHANNEL_ACTION["SUBSCRIBE"] = 0] = "SUBSCRIBE";
    CHANNEL_ACTION[CHANNEL_ACTION["UNSUBSCRIBE"] = 1] = "UNSUBSCRIBE";
})(CHANNEL_ACTION || (CHANNEL_ACTION = {}));
/** Способ сортировки */
export var SORT_BY;
(function (SORT_BY) {
    /** По алфавиту */
    SORT_BY[SORT_BY["ALPHABET"] = 1] = "ALPHABET";
    /** По приоритету */
    SORT_BY[SORT_BY["PRIORITY"] = 2] = "PRIORITY";
})(SORT_BY || (SORT_BY = {}));
export var DATA_TYPE_CODE;
(function (DATA_TYPE_CODE) {
    /** Фиктивная информация о матче, код 1. Только для тестовых целей/отладки.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_MATCH_INFO"] = 1] = "FALSE_MATCH_INFO";
    /** Фиктивная информация о балансе игрока, код 2. Только для тестовых целей/отладки.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_BALANCE_INFO"] = 2] = "FALSE_BALANCE_INFO";
    /** Фиктивная информация о рассчитанных ставках игрока, код 3. Только для тестовых целей/отладки. */
    DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_BETS_INFO"] = 3] = "FALSE_BETS_INFO";
    /** Информация о матче, код 4.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["MATCH_INFO"] = 4] = "MATCH_INFO";
    /** Баланс интернет игрока, код 5.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["BALANCE_INFO"] = 5] = "BALANCE_INFO";
    /** Количество нерасчитанных ставок интернет игрока, код 6.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["RAW_BETS_COUNT"] = 6] = "RAW_BETS_COUNT";
    /** Live-меню для сайта, полное, код 7.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MENU_DATA"] = 7] = "LIVE_MENU_DATA";
    /** Live-меню для мобильной версии, упрощённое, код 8.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MENU_MOBILE"] = 8] = "LIVE_MENU_MOBILE";
    /** Фильтр Live результатов, код 9.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_RESULTS_FILTER"] = 9] = "LIVE_RESULTS_FILTER";
    /** Live результаты, код 10.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_RESULTS"] = 10] = "LIVE_RESULTS";
    /** Табличная роспись Live матча для сайта, код 11 (см. Табличная роспись Live матча).*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_OUTCOMES_TABLE"] = 11] = "LIVE_OUTCOMES_TABLE";
    /** Табличная роспись Live матча для мобильной версии, код 12 (см. Табличная роспись Live матча).*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_OUTCOMES_TABLE_MOBILE"] = 12] = "LIVE_OUTCOMES_TABLE_MOBILE";
    /** Баланс ИРМ игрока, код 13.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["BALANCE_INFO_IRM"] = 13] = "BALANCE_INFO_IRM";
    /** Количество нерасчитанных ставок ИРМ игрока, код 14.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["RAW_BETS_COUNT_IRM"] = 14] = "RAW_BETS_COUNT_IRM";
    /** Live-матчи по спорту для мобильной версии, код 16 (см. MobileAppSportLiveMatches16.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_SPORT_MOBILE"] = 16] = "LIVE_MATCHES_BY_SPORT_MOBILE";
    /** Топ Live-матчи для мобильной версии, код 17 (см. MobileAppHotLiveMatches17.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_TOP_MOBILE"] = 17] = "LIVE_MATCHES_BY_TOP_MOBILE";
    /** Live-матчи с видео для мобильной версии, код 18 (см. MobileAppLiveMatchesWithVideo18.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_WITH_VIDEO_MOBILE"] = 18] = "LIVE_MATCHES_WITH_VIDEO_MOBILE";
    /** Live-матчи из избранного для мобильной версии, код 19 (см. MobileAppFavoriteLiveMatches19.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_FAVORITES_MOBILE"] = 19] = "LIVE_MATCHES_FAVORITES_MOBILE";
    /** Все Live-матчи для сайта, код 20 */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_ALL"] = 20] = "LIVE_MATCHES_ALL";
    /** Live-матчи по спорту для сайта, код 21 (см. WebSportLiveMatches21.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_SPORT"] = 21] = "LIVE_MATCHES_BY_SPORT";
    /** Live-матчи по чемпионату для сайта, код 22 (см. WebChampionshipLiveMatches22.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_CHAMPIONSHIP"] = 22] = "LIVE_MATCHES_BY_CHAMPIONSHIP";
    /** Топ Live-матчи для сайта, код 23 (см. WebHotLiveMatches23.ts) */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_TOP"] = 23] = "LIVE_MATCHES_BY_TOP";
    /** Live-матчи с видео для сайта, код 24 (см. WebLiveMatchesWithVideo24.ts) */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_WITH_VIDEO"] = 24] = "LIVE_MATCHES_WITH_VIDEO";
    /** Live-матчи из избранного для сайта, код 25 (см. WebFavoriteLiveMatches25.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_FAVORITES"] = 25] = "LIVE_MATCHES_FAVORITES";
})(DATA_TYPE_CODE || (DATA_TYPE_CODE = {}));



// WEBPACK FOOTER //
// ./src/web-frontend-core/ws-api/const/base.js